import {
  Button,
  Typography,
  List,
  Avatar,
  ListItem,
  IconButton,
  ListItemText,
  ListItemAvatar,
  Divider,
  CircularProgress,
} from "@mui/material";
import { Folder, Add } from "@mui/icons-material";
import React from "react";
import CenterDialog from "./CenterDialog.js";

function AddToGroupDialog({
  createdGroups,
  open,
  handleClose,
  handleCreate,
  handleAdd,
  errorMessage,
  busyGroupId,
}) {
  return (
    <CenterDialog
      open={open}
      handleClose={handleClose}
      hideCloseButton={true}
      openOnScroll={false}
      originalPadding={true}
    >
      <Button
        variant="contained"
        sx={{ width: "100%", float: "center", mt: 2 }}
        onClick={handleCreate}
      >
        Create new group
      </Button>
      <Divider sx={{ backgroundColor: "grey", mt: 4 }} />
      {createdGroups?.map((group, index) => (
        <List key={group._id} sx={{ width: "100%" }}>
          <ListItem
            disableGutters
            secondaryAction={
              <IconButton
                data-testid={`add-${index}`}
                edge="end"
                disabled={busyGroupId === group._id}
                onClick={() => handleAdd(group)}
              >
                {busyGroupId === group._id ? <CircularProgress size={20} /> : <Add />}
              </IconButton>
            }
          >
            <ListItemAvatar sx={{ alignItems: "flex-start" }}>
              <Avatar>
                <Folder />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={group.name}
              secondary={group.description}
              sx={{ mr: 5 }}
            />
          </ListItem>
        </List>
      ))}
      <div
        style={{
          marginTop: "24px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
        }}
      >
        <Button onClick={handleClose}>Cancel</Button>
      </div>
      <Typography color="delete" sx={{ mt: 1 }}>
        {errorMessage}
      </Typography>
    </CenterDialog>
  );
}

export default AddToGroupDialog;
